import React, { useContext, useRef, useEffect } from 'react';
import { withTheme } from 'styled-components';

import { Context } from '@store/store';
import useClickOutside from '@utils/useClickOutside';

import { isMobile } from 'react-device-detect';

import {
  StyledSpeechDropdown,

  StyledDivider,
  
  ButtonsWrapper,

  StyledSpeechSettingsWrapper,
    SpeechSpeedButton,
    SpeechSpeakerButton,
  StyledFeedbackLinkWrapper,
  
  StyledPlaybackControlButtonsWrapper,
    StyledBackwardStepButton,
    StyledPlayButton,
    StyledPauseButton,
    StyledForwardStepButton,
} from './speech-dropdown.styles';

function sleep(delay) {
    var start = new Date().getTime();
    while (new Date().getTime() < start + delay);
}

var currentSentenceIdx = 0;
var currentSentenceAudio = new Audio();
currentSentenceAudio.autoplay = false;
document.body.append(currentSentenceAudio);
var sentences = [];
var speechSpeed = 1.0;
var speechSpeaker = 'male_1';
var waitingForPageChange = false;
var currentBookId;

const ignorePages = [23, 24, 39, 40, 51, 52, 73, 74, 85, 86, 99, 100, 117, 118, 129, 130, 143, 144, 155, 156, 181, 182, 195, 196, 215, 216, 225, 226, 243, 244, 259, 260, 291, 292, 317, 318, 327, 328, 337, 338];

var isFirstAudioPlay = true;

var maxAudioPlayFails = 3;
var currentAudioPlayFails = 0;

var playAudioTimer = null;
function playAudioSafeInner() {
  console.log('----CALLED playAudioSafe playAudioSafeInner!');
  
  currentSentenceAudio.play()
    .then(() => {
      isFirstAudioPlay = false;
      currentAudioPlayFails = 0;
    })
    .catch((error) => {
      currentAudioPlayFails++;
      if (currentAudioPlayFails <= maxAudioPlayFails) {
        playAudioSafe();
      } else {
        // TODO
      }  
    });
}
function playAudioSafe() {
  if (isFirstAudioPlay === false) {
    currentSentenceAudio.play();
    return;
  }

  console.log('CALLED playAudioSafe!');
  if (playAudioTimer) {
    clearTimeout(playAudioTimer);
  }

  playAudioTimer = setTimeout(function() { 
    // currentSentenceAudio.removeEventListener('canplaythrough', playAudioSafeInner, false); 
    // currentSentenceAudio.addEventListener('canplaythrough', playAudioSafeInner, false);
    currentSentenceAudio.oncanplaythrough = null;
    currentSentenceAudio.oncanplaythrough = () => playAudioSafeInner(); 
    currentSentenceAudio.load();
  }, 300);
}

function startSpeakingFromScratch(state, dispatch) {
  try {
    waitingForPageChange = false;
    // console.log('CALLED startSpeakingFromScratch');
    // console.log('-state.currentPage', state.currentPage);

    // if (state.currentPage < 10) {
    //   console.log('-state.currentPage < 10');
    //   dispatch({ type: 'PLAY_SPEECH' }); // sic!
    //   dispatch({
    //     type: 'SET_CURRENT_PAGE',
    //     payload: 10,
    //   });
    //   return;
    // }

    // если sentences пустой, то популируем его
    if (sentences.length < 1) {
      // console.log('-sentences.length < 1, so extracting sentences');
      sentences = getSentences(state.bookId);
      if (sentences.length < 1) { // значит страница в игнор-листе
        stopAudio();
        currentSentenceAudio.src = '';
        currentSentenceAudio.load();
        sentences = [];
        currentSentenceIdx = 0;
        clearHighlights();
        waitingForPageChange = true;
        dispatch({ type: 'SET_NEXT_PAGE_BY_SPEECH' });
        return;
      }
    }

    // console.log('-sentences length:');
    // console.log(sentences.length);
    if (currentSentenceAudio.src != '' && currentSentenceAudio.src != window.location.href) {
      dispatch({ type: 'PLAY_SPEECH' });
      console.log('startSpeakingFromScratch: продолжаем с паузы: currentSentenceAudio', currentSentenceAudio);
      // продолжаем с паузы
      playAudioSafe();
    } else {
      // console.log('-typeof sentences[currentSentenceIdx]', typeof sentences[currentSentenceIdx]);
      if (typeof sentences[currentSentenceIdx] === 'undefined') {
        return;
      }
      dispatch({ type: 'PLAY_SPEECH' });
      console.log('startSpeakingFromScratch: НЕ с паузы, а с нуля: currentSentenceAudio', currentSentenceAudio);
      speakSentence(sentences[currentSentenceIdx], state, dispatch);
      preloadAndSetNextSentencesBlobsIfNeeded();
    }
  } catch (ex) {
    //
    console.log(ex);
  }
}

function stopAudio() {
  try {
    currentSentenceAudio.pause();
  } catch (ex) {
    console.log(ex);
  }
  try {
    currentSentenceAudio.currentTime = 0;
  } catch (ex) {
    console.log(ex);
  }
  try {
    // if (currentSentenceAudio.src != '' && currentSentenceAudio.src != window.location.href) {
      // console.log('stopAudio called ang gone inside');
      currentSentenceAudio.src = '';
      currentSentenceAudio.load();
    // }
  } catch (ex) {
    //
    console.log(ex);
  }
}

const speechDebounce = (callback, wait) => {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback(...args);
    }, wait);
  };
}

function goForward(state, dispatch) {
  stopAudio();
  dispatch({ type: 'PLAY_SPEECH' });

  if (sentences.length < 1 || (state.speechState == 'STOPPED' && currentSentenceIdx == 0)) {
    startSpeakingFromScratch(state, dispatch);
  }

  currentSentenceIdx++;
  clearHighlights();
  try {
    highlightSpans(sentences[currentSentenceIdx].spans);
  } catch (e) {
    //
    console.log(e);
  }

  debouncedGoForwardInner(state, dispatch);
}
const debouncedGoForwardInner = speechDebounce((state, dispatch) => {
  // случай, когда оказывается, что надо перелистнуть страницу:
  if (currentSentenceIdx >= sentences.length) {
    stopAudio();
    currentSentenceAudio.src = '';
    currentSentenceAudio.load();
    sentences = [];
    currentSentenceIdx = 0;
    clearHighlights();
    waitingForPageChange = true;
    dispatch({ type: 'SET_NEXT_PAGE_BY_SPEECH' });
    return;
  }

  if (typeof sentences[currentSentenceIdx] === 'undefined') {
    return;
  }
  // случай, когда не надо перелистывать страницу:
  speakSentence(sentences[currentSentenceIdx], state, dispatch);
  preloadAndSetNextSentencesBlobsIfNeeded();
}, 750);

function goBackwards(state, dispatch) {
  stopAudio();
  dispatch({ type: 'PLAY_SPEECH' });

  if (sentences.length < 1 || (state.speechState == 'STOPPED' && currentSentenceIdx == 0)) {
    startSpeakingFromScratch(state, dispatch);
  }

  currentSentenceIdx--;
  clearHighlights();
  try {
    highlightSpans(sentences[currentSentenceIdx].spans);
  } catch (e) {
    //
    console.log(e);
  }

  debouncedGoBackwardsInner(state, dispatch);
}
const debouncedGoBackwardsInner = speechDebounce((state, dispatch) => {
  // случай, когда оказывается, что надо перелистнуть страницу:
  if (currentSentenceIdx < 0) {
    stopAudio();
    currentSentenceAudio.src = '';
    currentSentenceAudio.load();
    sentences = [];
    currentSentenceIdx = 0;
    clearHighlights();
    waitingForPageChange = true;
    dispatch({ type: 'SET_PREV_PAGE_BY_SPEECH' });
    return;
    // TODO: нужно озвучивать именно последнее предложение
  }

  if (typeof sentences[currentSentenceIdx] === 'undefined') {
    return;
  }
  // случай, когда не надо перелистывать страницу:
  speakSentence(sentences[currentSentenceIdx], state, dispatch);
  // тут прелоадинг не делаем (в отличие от goForward())
}, 750);

function pauseSpeaking(state, dispatch) {
  try {
    currentSentenceAudio.pause();
  } catch (ex) {
    //
    console.log(ex);
  }
  try {
    if (!currentSentenceAudio.src || currentSentenceAudio.src == '' || currentSentenceAudio.src === window.location.href) {
      return;
    }
    dispatch({ type: 'PAUSE_SPEECH' });
  } catch (ex) {
    //
    console.log(ex);
  }
}

// zxc
function handleCurrentSentenceAudioEndedEvent(state, dispatch) {
  console.log('handleCurrentSentenceAudioEndedEvent');
  try {
    currentSentenceIdx += 1;

    if (currentSentenceIdx >= sentences.length) {
      stopAudio();
      currentSentenceAudio.src = '';
      currentSentenceAudio.load();
      sentences = [];
      currentSentenceIdx = 0;
      clearHighlights();
      waitingForPageChange = true;
      dispatch({ type: 'SET_NEXT_PAGE_BY_SPEECH' });
      return;
    }

    if (typeof sentences[currentSentenceIdx] === 'undefined') {
      return;
    }
    speakSentence(sentences[currentSentenceIdx], state, dispatch);
    preloadAndSetNextSentencesBlobsIfNeeded();
  } catch (ex) {
    //
    console.log(ex);
  }
}

function handleCurrentSentenceAudioPausedEvent(state, dispatch) {
  dispatch({ type: 'PAUSE_SPEECH' });
}

function handleCurrentSentenceAudioPlayedEvent(state, dispatch) {
  dispatch({ type: 'PLAY_SPEECH' });
}

function clearHighlights() {
  try {
    document.querySelectorAll('.speech-highlight').forEach(el => el.remove());
  } catch (ex) {
    //
    console.log(ex);
  }
}

function getTransformScaleY(transformValue) {
    const matrixRegex = /matrix\((-?\d*\.?\d+),\s*0,\s*0,\s*(-?\d*\.?\d+),\s*0,\s*0\)/;
    const matches = transformValue.match(matrixRegex);
    return matches[2];
}
function getTransformOriginY(element) {
  const transformOrigin = getComputedStyle(element)['transform-origin'];
  const [, yValue] = transformOrigin.split(' ');
  
  if (yValue.endsWith('%')) {
    const percentage = parseFloat(yValue);
    return (percentage / 100) * element.offsetHeight;
  }
  
  return parseFloat(yValue);
}
function highlightSpans(spans) {
  try {
    if (spans === undefined || spans === null || spans.length == 0) {
      return;
    }

    const bottomValues = spans.map(span => getCssBottomPropertyInt(span));
    const minBottom = Math.min(...bottomValues);
    const maxBottom = Math.max(...bottomValues);
    // console.log('minBottom:', minBottom, 'maxBottom:', maxBottom);

    const transformOriginYValues = spans.map(span => getTransformOriginY(span));
    const minTransformOriginY = Math.min(...transformOriginYValues);
    const maxTransformOriginY = Math.max(...transformOriginYValues);
    // console.log('minTransformOriginY:', minTransformOriginY, 'maxTransformOriginY:', maxTransformOriginY);

    const threshold = 2.5;
    let groups = [];
    spans.forEach(span => {
      const bottom = getCssBottomPropertyInt(span);
      let group = groups.find(
        group => ((group.bottom + threshold >= bottom) && (group.bottom - threshold < bottom))
      );
      if (!group) {
        group = { bottom: bottom, spans: [] };
        groups.push(group);
      }
      group.spans.push(span);  
    });

    let topGroup = null;
    for (let group of groups) {
      group.spans = removeEmptySpansFromBeginningAndEndOfArr(group.spans);
      if (group.spans === undefined || group.spans === null || group.spans.length == 0) {
        continue;
      }
      let firstSpan = group.spans[0];
      let lastSpan = group.spans[group.spans.length - 1];

      if (!topGroup) {
        topGroup = group;
      } else if (getCssPropertyInt(lastSpan, 'bottom') > getCssPropertyInt(topGroup.spans[topGroup.spans.length - 1], 'bottom')) {
        topGroup = group;
      }

      const fakeWrapperEl = document.createElement('div');
      fakeWrapperEl.classList.add("speech-highlight");
      fakeWrapperEl.style.position = "absolute";

      fakeWrapperEl.style.left = ((getCssPropertyInt(firstSpan, 'left') ?? 0) - 3) + 'px';
      
      // fakeWrapperEl.style.right = (getCssPropertyInt(lastSpan, 'right') ?? 0) + 'px';
      fakeWrapperEl.style.right = ((lastSpan.offsetParent.offsetWidth - lastSpan.offsetLeft - lastSpan.offsetWidth * extractTransformMatrixScaleX(lastSpan)) - 3) + 'px';

      // console.log('getComputedStyle(lastSpan).right', getComputedStyle(lastSpan).right);
      // console.log('lastSpan', lastSpan);
      // console.log('fakeWrapperEl.style.right', fakeWrapperEl.style.right);

      fakeWrapperEl.style.bottom = (getCssPropertyInt(lastSpan, 'bottom') + 1) + 'px';
      fakeWrapperEl.style.height = (getCssPropertyInt(lastSpan, 'height') - 3)  + 'px';
      fakeWrapperEl.style['transform-origin'] = getComputedStyle(lastSpan)['transform-origin'];
      fakeWrapperEl.style['transform'] = adaptTransform(getComputedStyle(lastSpan)['transform']);
      
      fakeWrapperEl.style.background = "rgba(255, 255, 0, 0.5)";
      // fakeWrapperEl.style.boxShadow = "0px 0px 15px 5px rgba(255,255,0,0.5)";
      fakeWrapperEl.style.borderRadius = "10px";

      fakeWrapperEl.style.zIndex = "99999";

      // let pcEl = firstSpan.closest('.pc');
      // pcEl.appendChild(fakeWrapperEl);
      // pcEl.prepend(fakeWrapperEl);
    }

    const topGroupLastSpan = topGroup.spans[topGroup.spans.length - 1];
    const topGroupHeight = (getCssPropertyInt(topGroupLastSpan, 'height') - 3);
    const topGroupTransformScaleY = getTransformScaleY(adaptTransform(getComputedStyle(topGroupLastSpan)['transform']));
    const largeFakeWrapperEl = document.createElement('div');
    largeFakeWrapperEl.style.background = "rgba(255, 255, 0, 0.5)";
    largeFakeWrapperEl.style.boxShadow = (isMobile) ? "0px 0px 3px 3px rgba(255, 255, 0, 0.5)" : "0px 0px 8px 5px rgba(255, 255, 0, 0.5)";
    // largeFakeWrapperEl.style.borderRadius = "10px";
    largeFakeWrapperEl.style.zIndex = "99999";
    largeFakeWrapperEl.style.position = "absolute";
    largeFakeWrapperEl.style.left = 0;
    largeFakeWrapperEl.style.right = 0;

    largeFakeWrapperEl.style['height'] = (maxBottom - minBottom + (topGroupHeight * topGroupTransformScaleY)) + 'px';
    largeFakeWrapperEl.style['bottom'] = (minBottom - 2) + 'px';
    // largeFakeWrapperEl.style['transform-origin'] = '0px ' + ((minTransformOriginY + maxTransformOriginY)*0.5) + 'px';
    // largeFakeWrapperEl.style['transform-origin'] = '0px ' + maxTransformOriginY + 'px';
    // largeFakeWrapperEl.style['transform'] = adaptTransform(getComputedStyle(spans[0])['transform']);
    largeFakeWrapperEl.classList.add("speech-highlight");

    let pcEl = spans[0].closest('.pc');
    pcEl.appendChild(largeFakeWrapperEl);
    pcEl.prepend(largeFakeWrapperEl);

  } catch (ex) {
    //
    console.log(ex);
  }
}



// function findGroupForSpan(spanBottom, groups, threshold) {
//   return groups.find(group => Math.abs(group.bottom - spanBottom) <= threshold);
// }

function extractTransformMatrixScaleX(el) {
  try {
    return getComputedStyle(el)['transform'].match(/matrix\((.*?)\,/i)[1];
  } catch (ex) {
    //
    console.log(ex);
  }
}

function adaptTransform(transformStr) {
  try {
    return transformStr.replace(/matrix\(.*?\,/i, 'matrix(1.0,');
  } catch (ex) {
    //
    console.log(ex);
  }
}

function preloadAndSetNextSentencesBlobsIfNeeded() {
  if (!(typeof sentences[currentSentenceIdx + 1] === 'undefined')) {
    preloadAndSetSentenceBlobIfNeeded(sentences[currentSentenceIdx + 1]);
  }

  // if (!(typeof sentences[currentSentenceIdx + 2] === 'undefined')) {
  //   preloadAndSetSentenceBlobIfNeeded(sentences[currentSentenceIdx + 2]);
  // }

  // if (!(typeof sentences[currentSentenceIdx + 3] === 'undefined')) {
  //   preloadAndSetSentenceBlobIfNeeded(sentences[currentSentenceIdx + 3]);
  // }
}

function preloadAndSetSentenceBlobIfNeeded(sentence) {
  try {
    if (Object.hasOwn(sentence?.audioBlobs || {}, speechSpeaker)) {
      return;
    }

    // если блоба нету, то асинхронно загружаем его и устанавливаем в проперти
    let formData = new FormData();
    formData.append('sentence', sentence.text);
    formData.append('speaker_id', speechSpeaker);
    formData.append('book_id', currentBookId);
    const url = "https://new.nlrs.ru/tts/tts";
    fetch(url, {
        method : "POST",
        body: formData
    }).then(
      (response) => response.json()
    ).then((data) => {
      fetch(data?.audio?.url)
        .then(function(response) {return response.blob()})
        .then(function(blob) {
          // console.log('preloaded sentence audioblob', data?.audio?.speaker_id);
          if (!sentence.audioBlobs) {
            sentence.audioBlobs = {};
          }
          sentence.audioBlobs[data?.audio?.speaker_id] = URL.createObjectURL(blob); // здесь делается запрос для получения блоба
       });
    });
  } catch (ex) {
    //
    console.log(ex);
  }
}

function speakSentence(sentence, state, dispatch) {
  try {
    stopAudio();

    if (!sentence) {
      clearHighlights();
      handleCurrentSentenceAudioEndedEvent(state, dispatch);
      return;
    }

    clearHighlights();
    highlightSpans(sentence.spans);

    // if (Object.hasOwn(sentence, 'audioBlob')) {
    if (Object.hasOwn(sentence?.audioBlobs || {}, speechSpeaker)) {
      // console.log("USING CACHED BLOB");
      stopAudio();
      currentSentenceAudio.src = sentence.audioBlobs[speechSpeaker];
      try {
        currentSentenceAudio.pause(); 
      } catch (ex) {
        console.log(ex);
      }
      try {
        currentSentenceAudio.currentTime = 0;  
      } catch (ex) {
        console.log(ex);
      }
      try {
        currentSentenceAudio.playbackRate = speechSpeed;  
      } catch (ex) {
        console.log(ex);
      }

      currentSentenceAudio.onended = null;
      currentSentenceAudio.onpause = null;
      currentSentenceAudio.onplay = null;

      currentSentenceAudio.onended = () => handleCurrentSentenceAudioEndedEvent(state, dispatch);
      currentSentenceAudio.onpause = () => handleCurrentSentenceAudioPausedEvent(state, dispatch);
      currentSentenceAudio.onplay = () => handleCurrentSentenceAudioPlayedEvent(state, dispatch);

      console.log('speakSentence: if true: currentSentenceAudio', currentSentenceAudio);
      playAudioSafe();
    } else {
      // console.log("USING REMOTE");
      let formData = new FormData();
      formData.append('sentence', sentence.text);
      formData.append('speaker_id', speechSpeaker);
      formData.append('book_id', currentBookId);
      const url = "https://new.nlrs.ru/tts/tts";
      fetch(url, {
          method : "POST",
          body: formData
      }).then(
        (response) => response.json()
      ).then((data) => {
        stopAudio();
        fetch(data?.audio?.url)
          .then(function(response) {return response.blob()})
          .then(function(blob) {
            if (!sentence.audioBlobs) {
              sentence.audioBlobs = {};
            }
            sentence.audioBlobs[data?.audio?.speaker_id] = URL.createObjectURL(blob); // здесь делается запрос для получения блоба
            stopAudio();
            currentSentenceAudio.src = sentence.audioBlobs[data?.audio?.speaker_id];
            try {
              currentSentenceAudio.pause();
            } catch (ex) {
              console.log(ex);
            }
            try {
              currentSentenceAudio.currentTime = 0;
            } catch (ex) {
              console.log(ex);
            }
            try {
              currentSentenceAudio.playbackRate = speechSpeed;
            } catch (ex) {
              console.log(ex);
            }
            
            currentSentenceAudio.onended = null;
            currentSentenceAudio.onpause = null;
            currentSentenceAudio.onplay = null;

            currentSentenceAudio.onended = () => handleCurrentSentenceAudioEndedEvent(state, dispatch);
            currentSentenceAudio.onpause = () => handleCurrentSentenceAudioPausedEvent(state, dispatch);
            currentSentenceAudio.onplay = () => handleCurrentSentenceAudioPlayedEvent(state, dispatch);

            console.log('speakSentence: if false: currentSentenceAudio', currentSentenceAudio);
            playAudioSafe();
         });
      });  
    }
  } catch (ex) {
    //
    console.log(ex);
  }
}

function getCssBottomPropertyInt(tEl) {
  try {
    const computedStyle = getComputedStyle(tEl);
    let strVal = computedStyle.bottom;
    strVal = strVal.substring(0, strVal.indexOf('px'));

    let floatVal = parseFloat(strVal);

    let intVal = Math.round(floatVal);

    return intVal;
  } catch (exception) {
    return 99999;
  }
}

function getCssPropertyStr(tEl, property) {
  try {
    const computedStyle = getComputedStyle(tEl);
    const strVal = computedStyle[property];
    return strVal;
  } catch (exception) {
    return null;
  }
}

function getCssPropertyInt(tEl, property) {
  try {
    const computedStyle = getComputedStyle(tEl);
    let strVal = computedStyle[property];
    strVal = strVal.substring(0, strVal.indexOf('px'));

    let floatVal = parseFloat(strVal);

    let intVal = Math.round(floatVal);

    return intVal;
  } catch (exception) {
    return null;
  }
}

function removeEmptySpansFromBeginningAndEndOfArr(spans) {
  try {
    let startIndex = 0;
    let endIndex = spans.length - 1;
    
    while (startIndex < spans.length && (spans[startIndex].textContent.trim() || '') === '') {
      // console.log('spans[startIndex].textContent.trim()', spans[startIndex].textContent.trim());
      startIndex++;
    }

    while (endIndex >= 0 && (spans[endIndex].textContent.trim() || '') === '') {
      endIndex--;
    }

    return spans.slice(startIndex, endIndex + 1);
  } catch (ex) {
    return spans;
  }
}

function getSentences(bookId) {
  try {
    const containsEndOfSentenceRegex = /[\.!\?:]/;
    const nonemptySentenceRegex    = /[\sа-яһөҕүҥ]/i;
    let localSentences = [];
    let globalIdx      = 0;

    // Проходим по каждому блоку .pf отдельно
    for (const pfEl of document.querySelectorAll('div.pf')) {
      const hexPageNo = pfEl.getAttribute('data-page-no');
      const pageNo    = parseInt(hexPageNo, 16);
      if (isNaN(pageNo)) continue;

      // Для bookId==8888 — фильтр по списку ignorePages;
      // для bookId==120169 — страницы вне диапазона
      const skipWholePage = (bookId === 8888 && ignorePages.includes(pageNo))
                         || (bookId === 120169 && (pageNo < 48 || pageNo > 185));
      if (skipWholePage) continue;

      // Собираем все подходящие span внутри этого pf
      const spans = Array
        .from(pfEl.querySelectorAll('div.t'))
        .filter(span => {
          // для bookId==8888: если страница в ignorePages и span—италик, пропускаем
          if (bookId === 8888 &&
              ignorePages.includes(pageNo) &&
              getComputedStyle(span).fontStyle === 'italic') {
            return false;
          }
          return true;
        });

      // Буферы внутри одного pf
      let textBuf  = '';
      let spansBuf = [];

      for (const tEl of spans) {
        const bottom = getCssBottomPropertyInt(tEl);

        // фильтры по «низу» для конкретных книг
        if (bookId === 8888 && bottom > 430) continue;
        if (bookId === 120169 && bottom > 540) continue;

        if (bookId === 120169) {
          const left = getCssPropertyInt(tEl, 'left');
          if (pageNo % 2 === 0 ? left < 70 : left < 60) continue;
          if (/^[\d\s]+$/.test(tEl.textContent.trim())) continue;
          if (getCssPropertyInt(tEl, 'font-size') < 35) continue;
          if (/\bTimesNewRomanPSMT\b/.test(getCssPropertyStr(tEl, 'font-family') || '')) continue;
          if (/\bSegoeUI Bold\b/.test(getCssPropertyStr(tEl, 'font-family') || '')) continue;
        }

        // накапливаем
        textBuf += tEl.textContent;
        spansBuf.push(tEl);

        const TTS_WHOLE_PAGE = false; // (bookId == 120169)
        // Мид-пейдж сброс
        if (!TTS_WHOLE_PAGE &&
            containsEndOfSentenceRegex.test(tEl.textContent) &&
            textBuf.trim().length > 30) {

          const sentenceText = textBuf.trim();
          const cleanSpans   = removeEmptySpansFromBeginningAndEndOfArr(spansBuf);

          if (cleanSpans.length && nonemptySentenceRegex.test(sentenceText)) {
            localSentences.push({
              text: sentenceText,
              spans: cleanSpans,
              idx: globalIdx++
            });
          }
          textBuf  = '';
          spansBuf = [];
        }
      }

      // Хвост внутри pf — сбрасываем вне зависимости от bookId
      const tailText  = textBuf.trim();
      const tailSpans = removeEmptySpansFromBeginningAndEndOfArr(spansBuf);
      if (tailSpans.length && nonemptySentenceRegex.test(tailText)) {
        localSentences.push({
          text: tailText,
          spans: tailSpans,
          idx: globalIdx++
        });
      }
    }

    return localSentences;
  } catch (ex) {
    console.error(ex);
    return [];
  }
}

const SpeechDropdown = ({ bookId, theme, editorButtonIsPresent }) => {
  const [state, dispatch] = useContext(Context);
  const wrapperRef = useRef(null);

  useClickOutside(wrapperRef, 'dropdown');

  useEffect(() => {
      // console.log("PG CHNGD, new state.currentPage:", state.currentPage, ', waitingForPageChange is ', state.speechState);
      // if (state.speechState == 'PLAYING') {
      if (waitingForPageChange) {
        waitingForPageChange = false;
        setTimeout(function () {
          requestAnimationFrame(function() {
            try {
              document.querySelector('meta[name=viewport]').setAttribute('content', "initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0");
              window.scrollTo(0, 0);
              document.querySelectorAll('#page-container, #page-container > div, #page-container > div > div').forEach(element => element.scrollTop = 0);
            } catch (ex) {
              console.log(ex);
            }
            startSpeakingFromScratch(state, dispatch);
        })
        }, 1000);
      } else {
        // значит страницу поменяли вручную
        stopAudio();
        currentSentenceAudio.src = '';
        currentSentenceAudio.load();
        sentences = [];
        currentSentenceIdx = 0;
        clearHighlights();
        dispatch({ type: 'STOP_SPEECH' });
      }
  },[state.currentPage])

  useEffect(() => {
    stopAudio();
    currentSentenceAudio.src = '';
    currentSentenceAudio.load();
    sentences = [];
    currentSentenceIdx = 0;
    clearHighlights();
    dispatch({ type: 'STOP_SPEECH' });
  },[state.isSinglePageMode])

  useEffect(() => {
    currentBookId = state.bookId;
  },[state.bookId])

  useEffect(()=>{
    document.addEventListener("speech-speed-change", function(e) {
      speechSpeed = e.detail.newSpeechSpeed;
      if (currentSentenceAudio.src != '' && currentSentenceAudio.src != window.location.href) {
        try {
          currentSentenceAudio.playbackRate = speechSpeed;  
        } catch (ex) {
          console.log(ex);
        }
      }
    });
  }, []);

  useEffect(()=>{
    document.addEventListener("speech-speaker-change", function(e) {
      speechSpeaker = e.detail.newSpeechSpeaker;
      if (currentSentenceAudio.src != '' && currentSentenceAudio.src != window.location.href) {
        if (!currentSentenceAudio.paused) {
          stopAudio();
          currentSentenceAudio.src = '';
          currentSentenceAudio.load();
          dispatch({ type: 'PLAY_SPEECH' });
          speakSentence(sentences[currentSentenceIdx], state, dispatch);
          preloadAndSetNextSentencesBlobsIfNeeded();
        } else {
          stopAudio();
          currentSentenceAudio.src = '';
          currentSentenceAudio.load();
        }
      }
    });
  }, []);

  if (!([8888, 12809, 120169].includes(bookId))) {
    return null;
  }

  return (
    <StyledSpeechDropdown
      isOpened={state.isSpeechDropdownOpened}
      data-is-opened={state.isSpeechDropdownOpened}
      ref={wrapperRef}
      editorButtonIsPresent={editorButtonIsPresent}
    >
      <StyledPlaybackControlButtonsWrapper>
        
        <StyledBackwardStepButton
            onClick={() =>
              goBackwards(state, dispatch)
            }
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M267.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160L64 241V96c0-17.7-14.3-32-32-32S0 78.3 0 96V416c0 17.7 14.3 32 32 32s32-14.3 32-32V271l11.5 9.6 192 160z"/></svg>
        </StyledBackwardStepButton>

        {state.speechState == 'PLAYING' ? (
            <StyledPauseButton
            onClick={() =>
              pauseSpeaking(state, dispatch)
            }
          >
            <svg viewBox="0 0 64 64">
              <path fill-rule="nonzero" d="M32 0a32 32 0 1 0 0 64 32 32 0 0 0 0-64zm-4 40a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V24c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v16zm16 0a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V24c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v16z"></path>
            </svg>
          </StyledPauseButton>
        ) : (
          <StyledPlayButton
            onClick={() => {
                if (isFirstAudioPlay) {
                  currentSentenceAudio.autoplay = true;
                  let origSrc = currentSentenceAudio.src;
                  console.log('origSrc', origSrc);
                  currentSentenceAudio.src = "data:audio/mpeg;base64,SUQzBAAAAAABEVRYWFgAAAAtAAADY29tbWVudABCaWdTb3VuZEJhbmsuY29tIC8gTGFTb25vdGhlcXVlLm9yZwBURU5DAAAAHQAAA1N3aXRjaCBQbHVzIMKpIE5DSCBTb2Z0d2FyZQBUSVQyAAAABgAAAzIyMzUAVFNTRQAAAA8AAANMYXZmNTcuODMuMTAwAAAAAAAAAAAAAAD/80DEAAAAA0gAAAAATEFNRTMuMTAwVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQsRbAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQMSkAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV";
                  currentSentenceAudio.autoplay = false;
                  currentSentenceAudio.src = origSrc;
                  isFirstAudioPlay = false;
                }
                if (state.bookId == 8888 && (state.currentPage < 10 || state.currentPage > 350)) {
                  waitingForPageChange = true;
                  dispatch({
                    type: 'SET_CURRENT_PAGE',
                    payload: 10,
                  });
                  return;
                }
                if (state.bookId == 120169 && (state.currentPage < 47 || state.currentPage > 186)) {
                  waitingForPageChange = true;
                  dispatch({
                    type: 'SET_CURRENT_PAGE',
                    payload: 47,
                  });
                  return;
                }
                startSpeakingFromScratch(state, dispatch);
              }
            }
          >
            <svg viewBox="0 0 64 64">
              <path d="M32 0a32 32 0 1 1 0 64 32 32 0 0 1 0-64zm-9 17.8c-1 0-1.7.6-1.7 1.4v25.6c0 .8.8 1.4 1.7 1.4 0 0 25-12 26.2-13.1 1-1 .3-1.9.1-2.1z"></path>
            </svg>
          </StyledPlayButton>
        )}

        <StyledForwardStepButton
          onClick={() =>
            goForward(state, dispatch)
          }
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4l192 160L256 241V96c0-17.7 14.3-32 32-32s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V271l-11.5 9.6-192 160z"/></svg>
        </StyledForwardStepButton>

      </StyledPlaybackControlButtonsWrapper>

      <StyledDivider />

      <StyledSpeechSettingsWrapper>
        <span>Голос</span>
        <ButtonsWrapper>
          <SpeechSpeedButton
            active={state.speechSpeaker === 'male_1'}
            onClick={() =>
              dispatch({ type: 'SET_SPEECH_SPEAKER', payload: 'male_1' })
            }
          >Мужской</SpeechSpeedButton>

          <SpeechSpeedButton
            active={state.speechSpeaker === 'female_1'}
            onClick={() =>
              dispatch({ type: 'SET_SPEECH_SPEAKER', payload: 'female_1' })
            }
          >Женский</SpeechSpeedButton>

          {/* <SpeechSpeedButton
            active={state.speechSpeaker === 'male_2'}
            onClick={() =>
              dispatch({ type: 'SET_SPEECH_SPEAKER', payload: 'male_2' })
            }
          >Муж. 2</SpeechSpeedButton> */}

        </ButtonsWrapper>
      </StyledSpeechSettingsWrapper>

      <StyledDivider />

      <StyledSpeechSettingsWrapper>
        <span>Скорость</span>
        <ButtonsWrapper>
          {/* <SpeechSpeedButton
            active={state.speechSpeed === 0.8}
            onClick={() =>
              dispatch({ type: 'SET_SPEECH_SPEED', payload: 0.8 })
            }
          >0.8x</SpeechSpeedButton> */}
          
          <SpeechSpeedButton
            active={state.speechSpeed === 1.0}
            onClick={() =>
              dispatch({ type: 'SET_SPEECH_SPEED', payload: 1.0 })
            }
          >Обычная</SpeechSpeedButton>
          
          <SpeechSpeedButton
            active={state.speechSpeed === (state.bookId == 120169 ? 1.1 : 1.2)}
            onClick={() =>
              dispatch({ type: 'SET_SPEECH_SPEED', payload: (state.bookId == 120169 ? 1.1 : 1.2) })
            }
          >Ускоренная</SpeechSpeedButton>
        </ButtonsWrapper>
      </StyledSpeechSettingsWrapper>    
      <StyledDivider />
      <StyledFeedbackLinkWrapper>
        <a href="mailto:elib@nlrs.ru?subject=Синтезатор%20речи">Обратная связь</a>
      </StyledFeedbackLinkWrapper>
      </StyledSpeechDropdown>
  );
};

export default withTheme(SpeechDropdown);
